import { Store } from 'redux';

import { MESSAGES, MODE } from '../../constants';
import { createModeMessage } from '../common/messageCreators';
import { chatActions } from '../common/reducers/chat';
import { selectIsLiveChat, selectItems } from '../common/selectors/chat';

const timeOut = window.isTest ? 1500 : 60000;

export const liveChatWaitingCheck = (store: Store) => {
  setTimeout(() => {
    const { dispatch, getState } = store;
    const state = getState();
    const isLiveChat = selectIsLiveChat(state);
    if (!isLiveChat) {
      return;
    }
    const chatItems = selectItems(state);
    const lastChangeModeIndex = chatItems.findIndex((item) => item.type === MESSAGES.CHANGE_MODE);

    const hasAgentReplied = Boolean(
      chatItems
        .slice(lastChangeModeIndex === -1 ? 0 : lastChangeModeIndex)
        .find(
          (item) =>
            item.type === MESSAGES.AGENT_MESSAGE || (item.type === MESSAGES.AGENT_STATUS && item.isJoined),
        ),
    );
    if (!hasAgentReplied) {
      dispatch(
        chatActions.addItem(
          createModeMessage({
            mode: MODE.LIVECHAT,
            isTransferred: false,
            overwriteWithKey: 'live_chat_your_next',
            clientOnly: true,
          }),
        ),
      );
    }
  }, timeOut);
};
